import { useDataChange } from 'Simple/Data.js'

export function useOnFilterClickAll(props) {
  let change = useDataChange({
    context: 'tab',
    path: 'selected.ledger.notes.filter_by',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change([])
  }
}
